"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncStateStatus = void 0;
exports.AsyncStateStatus = {
    ERROR: 'ERROR',
    INITIAL: 'INITIAL',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
};
//# sourceMappingURL=AsyncFnState.js.map